








































import { defineComponent, ref, PropType } from '@vue/composition-api';
import { UpdateProfilePayload } from '@oare/types';
import sl from '@/serviceLocator';
import Reathenticate from '@/views/Authentication/Verification/Reautheticate.vue';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    currentValue: {
      type: String,
      required: true,
    },
    property: {
      type: String as PropType<keyof UpdateProfilePayload>,
      required: true,
    },
  },
  components: {
    Reathenticate,
  },
  setup({ currentValue, property }, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const isEditing = ref(false);
    const editedValue = ref(currentValue);
    const loading = ref(false);
    const verifyPasswordDialog = ref(false);

    const triggerEdit = () => {
      if (property === 'email') {
        verifyPasswordDialog.value = true;
      } else {
        isEditing.value = true;
      }
    };

    const unlockVerification = () => {
      isEditing.value = true;
    };

    const cancelEdit = () => {
      editedValue.value = currentValue;
      isEditing.value = false;
    };

    const updateValue = async () => {
      loading.value = true;
      try {
        await server.updateProfile({
          [property]: editedValue.value,
        });
        actions.showSnackbar('Profile successfully updated');
        isEditing.value = false;
        emit('updated', editedValue.value);
      } catch (err) {
        actions.showErrorSnackbar(
          'There was an error updating your profile.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    };

    return {
      editedValue,
      isEditing,
      cancelEdit,
      updateValue,
      loading,
      verifyPasswordDialog,
      triggerEdit,
      unlockVerification,
    };
  },
});
